import React, { useState } from 'react';
import { Input, Form, FormGroup, Button, Container, Row, Col } from 'reactstrap';
// Translation Higher Order Component
import { translate } from 'react-switch-lang';

const RejseForm = ({ t }) => {
	const [ status, setStatus ] = useState({
		submitted: false,
		submitting: false,
		info: { error: false, msg: null }
	});

	const [ inputs, setInputs ] = useState({
		email: '',
		name: '',
		telephone: '',
		message: ''
	});

	const handleResponse = (status, msg) => {
		if (status === 200) {
			setStatus({
				submitted: true,
				submitting: false,
				info: { error: false, msg: msg }
			});
			setInputs({
				email: '',
				name: '',
				telephone: '',
				message: ''
			});
		} else {
			setStatus({
				info: { error: true, msg: msg }
			});
		}
	};

	const handleOnChange = (e) => {
		e.persist();
		setInputs((prev) => ({
			...prev,
			[e.target.id]: e.target.value
		}));
		setStatus({
			submitted: false,
			submitting: false,
			info: { error: false, msg: null }
		});
	};

	const handleOnSubmit = async (e) => {
		e.preventDefault();
		setStatus((prevStatus) => ({ ...prevStatus, submitting: true }));
		const res = await fetch('/api/sendForm', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(inputs)
		});
		const text = await res.text();
		handleResponse(res.status, text);
	};

	return (
		<Container>
			<Form onSubmit={handleOnSubmit}>
				<FormGroup>
					<label htmlFor="email">Email</label>
					<span className="red">*</span>
					<Input
						autoComplete="new-password"
						className="mb-3"
						id="email"
						type="email"
						placeholder="name@example.com"
						onChange={handleOnChange}
						required
						value={inputs.email}
					/>
					<Row>
						<Col>
							<label htmlFor="name">{t('contacts.firstname')}</label>
							<span className="red">*</span>
							<Input
								autoComplete="new-password"
								className="mb-3"
								id="name"
								type="text"
								placeholder="John"
								onChange={handleOnChange}
								required
								value={inputs.name}
							/>
						</Col>
						<Col>
							<label htmlFor="surename">{t('contacts.lastname')}</label>
							<span className="red">*</span>
							<Input
								autoComplete="new-password"
								className="mb-3"
								id="surename"
								type="text"
								placeholder="Doe"
								onChange={handleOnChange}
								required
								value={inputs.surename}
							/>
						</Col>
					</Row>
					<Row>
						<Col>
							<label htmlFor="cpr">CPR</label>
							<span className="red">*</span>
							<Input
								autoComplete="new-password"
								className="mb-3"
								id="cpr"
								type="text"
								placeholder="220587-4312"
								onChange={handleOnChange}
								required
								value={inputs.cpr}
							/>
						</Col>
						<Col>
							<label htmlFor="date">{t('contacts.date')}</label>
							<span className="red">*</span>
							<Input
								autoComplete="new-password"
								className="mb-3"
								id="date"
								type="date"
								placeholder="11/08/2021"
								onChange={handleOnChange}
								required
								value={inputs.date}
							/>
						</Col>
					</Row>
					<label htmlFor="telephone">{t('contacts.phone')}</label>
					<span className="red">*</span>
					<Input
						autoComplete="new-password"
						className="mb-3"
						id="telephone"
						type="tel"
						placeholder="40-(770)-888-444"
						onChange={handleOnChange}
						required
						value={inputs.telephone}
					/>
					<label htmlFor="comment">{t('contacts.comment')}</label>
					<Input
						className="mb-3"
						autoComplete="new-password"
						id="comment"
						onChange={handleOnChange}
						value={inputs.comment}
						bsSize="lg"
						placeholder={t('contacts.message_placeholder')}
						rows="3"
						type="textarea"
					/>
					<br />
					<Button className="booking_button mb-5" color="info" type="submit" disabled={status.submitting}>
						{!status.submitting ? !status.submitted ? (
							t('contacts.submit')
						) : (
							t('contacts.submitted')
						) : (
							t('contacts.submitting')
						)}
					</Button>
					{/* <br />
					{status.info.error && <div className="error">Error: {status.info.msg}</div>}
					{!status.info.error && status.info.msg && <div className="success">{status.info.msg}</div>} */}
				</FormGroup>
			</Form>
		</Container>
	);
};

export default translate(RejseForm);
